angular.module('aprima-bridge').factory('AndroidBridge', ['XamarinBridge', '_', function (XamarinBridge, _) {
    'use strict';

    var androidBridge = _.cloneDeep(XamarinBridge);

    //add properties unique to android here

    return androidBridge;
}]);
